import React from "react";
import { useTranslation } from "react-i18next";
import AiHomeImg from "./ai bot gif.gif";

import "./ai-hero.css";

const AiHero = () => {
  const { t } = useTranslation();

  const handleCall = () => {
    window.location.href = `tel:+92 323 2675312`;
  };

  const sectionScrollHandler = (sectionId) => {
    const section = document.getElementById(sectionId);

    if (section) {
      window.scrollTo({
        top: section.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <section id="ai_hero_section">
        <div id="ai_hero_text_div">
          <h1 id="ai_hero_main_hdng">Close More Deals With AI Assistant!</h1>
          <p id="ai_hero_text">
            Boost efficiency, engage leads 24/7, and simplify operations with
            MENA PropTech’s cutting-edge AI Assistant.
            <br />
            <b>Let AI Close More Deals For You!</b>
          </p>

          <div id="buttons_div">
            <button
              id="ai_learn_btn"
              onClick={() => sectionScrollHandler("form_section")}
            >
              Learn More
            </button>
            <button id="ai_call_btn" onClick={handleCall}>
              Consult Now
            </button>
          </div>
        </div>
        <div id="home_img_div">
          <img id="home_img" src={AiHomeImg} alt="" />
        </div>
      </section>
    </>
  );
};

export default AiHero;
